module.exports = __webpack_public_path__ + "static/img/logos_azteca_blanco.7c6bc97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/logos_azteca_blanco.png
// module id = 123
// module chunks = 0